import { render, staticRenderFns } from "./DataOptimizationBuckets.vue?vue&type=template&id=59cdfe1e&"
import script from "./DataOptimizationBuckets.vue?vue&type=script&lang=js&"
export * from "./DataOptimizationBuckets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports